import { AxiosStatic } from "axios";
import { Message } from "../../components/ai/ai.types";

export type IncidentsOpenAiClient = (prompt: Message[]) => Promise<Message[]>

export type OpenAiConfigForIncidents = {
    axios: AxiosStatic,
    baseURL?: string
    jwtTokenFn: () => Promise<string | undefined>,
    customisation: any
    debug?: boolean
}
export const openAiClientForIncidents = (config: OpenAiConfigForIncidents): IncidentsOpenAiClient => {
    const { axios, baseURL, jwtTokenFn, customisation, debug } = config;
    if (!baseURL) throw new Error('baseURL is required for open ai. Have you set up the .env file?');
    return async (messages: Message[]): Promise<Message[]> => {
        if (debug) console.log('openAiMessagesClient', messages, config);
        const jwtToken = await jwtTokenFn();
        const axiosInstance = axios.create({
            baseURL,
            headers: {
                Authorization: `Bearer ${jwtToken}`,
                'Content-Type': 'application/json',
            },
        });
        try {
            const response = await axiosInstance.post(`/service/completions`, {
                messages,
                ...customisation
            });
            return response.data.choices.map((x: any) => x.message);
        } catch (error) {
            console.error('Error calling openai:', messages, error);
            throw error;
        }
    };
};